import mutations from "./mutations";
import getters from "./getters";

export default {
  state: {
    submission_token: null,
    responses: [],
  },
  mutations,
  getters,
};
